import React, { useState } from "react";
import "./Help.css";
import pretragaImg from "../assets/images/pretraga.png";
import rezultatPretrageImg from "../assets/images/rezultat.png";
import prijavaMapaImg from "../assets/images/prijava-mapa.png";

// Guide images - Step 1: Habitat types
import pondImg from "../assets/images/guide/pond.jpg";
import swampImg from "../assets/images/guide/swamp.jpg";
import lakeImg from "../assets/images/guide/lake.jpg";
import springImg from "../assets/images/guide/spring.jpg";
import streamImg from "../assets/images/guide/stream.jpg";
import riverImg from "../assets/images/guide/river.jpg";
import canalImg from "../assets/images/guide/canal.jpg";
import wetMeadowImg from "../assets/images/guide/wet-meadow.jpg";
import peatBogImg from "../assets/images/guide/peat-bog.jpg";

// Guide images - Step 2: Water health
import waterClearImg from "../assets/images/guide/water-clear.jpg";
import waterCloudyImg from "../assets/images/guide/water-slightly-cloudy.jpg";
import waterMuddyImg from "../assets/images/guide/water-muddy.jpg";
import colorGreenImg from "../assets/images/guide/color-green.jpg";
import colorBrownImg from "../assets/images/guide/color-brown.jpg";
import colorGrayImg from "../assets/images/guide/color-gray.jpg";
import colorRedImg from "../assets/images/guide/color-red.jpg";
import algaeNoneImg from "../assets/images/guide/algae-none.jpg";
import algaeLittleImg from "../assets/images/guide/algae-little.jpg";
import algaeLotImg from "../assets/images/guide/algae-lot.jpg";

// Guide images - Step 3: Biodiversity
import floraWaterImg from "../assets/images/guide/flora-water.jpg";
import floraBankImg from "../assets/images/guide/flora-bank.jpg";
import floraNoneImg from "../assets/images/guide/flora-none.jpg";
import faunaFishImg from "../assets/images/guide/fauna-fish.jpg";
import faunaAmphibiansImg from "../assets/images/guide/fauna-amphibians.jpg";
import faunaBirdsImg from "../assets/images/guide/fauna-birds.jpg";
import faunaInsectsImg from "../assets/images/guide/fauna-insects.jpg";
import faunaReptilesImg from "../assets/images/guide/fauna-reptiles.jpg";
import faunaOtherImg from "../assets/images/guide/fauna-other.jpg";

// Guide images - Step 4: Threats
import threatChemicalImg from "../assets/images/guide/threat-chemical.jpg";
import threatBiologicalImg from "../assets/images/guide/threat-biological.jpg";
import threatWasteImg from "../assets/images/guide/threat-waste.jpg";
import threatErosionImg from "../assets/images/guide/threat-erosion.jpg";
import threatDroughtImg from "../assets/images/guide/threat-drought.jpg";
import threatBarrierImg from "../assets/images/guide/threat-barrier.jpg";
import threatOverfishingImg from "../assets/images/guide/threat-overfishing.jpg";
import threatLeadshotImg from "../assets/images/guide/threat-leadshot.jpg";
import threatRadioactiveImg from "../assets/images/guide/threat-radioactive.jpg";

const Help = () => {
  const [zoomedImg, setZoomedImg] = useState(null);

  const handleImageClick = (src, alt) => {
    setZoomedImg({ src, alt });
  };

  const handleZoomClose = () => {
    setZoomedImg(null);
  };

  return (
    <div className="help-container">
      {/* Sekcija 1: Kako pretraživati vlažna staništa */}
      <section className="help-section">
        <h2>Kako pretraživati vlažna staništa</h2>
        <p className="help-text">
          Pretraga vlažnih staništa je moguća preko mobilnog ili preko računara.
          Za filtriranje vlažnog staništa potrebno je kliknuti na <strong>pretragu</strong> (lupu) označenu na slici broj 1 ,
          Nakon toga će se pojaviti prozor (slika 2),
          Vlažna staništa je moguće pretražiti po datumu i tipu vlažnog staništa.
          Klikom na dugme <strong>Pretraži</strong> na mapi će se prikazati
          vlažna staništa po zadatim kriterijumima.
        </p>

        <div className="help-image-block">
          <img src={pretragaImg} alt="Pretraga wetland-a" className="help-image" />
          <p className="help-caption">Slika 1</p>
        </div>

        <div className="help-image-block">
          <img src={rezultatPretrageImg} alt="Rezultat pretrage požara" className="help-image" />
          <p className="help-caption">Slika 2</p>
        </div>
      </section>

      {/* Sekcija 2: Kako prijaviti wetland-e */}
      <section className="help-section">
        <h2>Kako prijaviti vlažna staništa</h2>
        <p className="help-text">
          Za prijavu vlažnog staništa potrebno je na mobilnom telefonu u browseru ukucati <strong>wetland.rs</strong> i kliknuti na dugme <strong>Pošalji</strong> (slika 1). Nakon toga otvara se forma na kojoj se unosi tip vlažnog staništa i komentar,
          a zatim se uslika vlažno stanište klikom na dugme <strong>Uslikaj</strong> (moguće je poslati jednu ili više fotografija vlažnog staništa).
          Nakon unosa podataka, klikom na <strong>Pošalji</strong>, prijava je poslata i vlažno stanište je uspešno prijavljeno.
        </p>

        <div className="help-image-block">
          <img src={prijavaMapaImg} alt="Mapa prijave vlažnog staništa" className="help-image" />
          <p className="help-caption">Slika 1</p>
        </div>
      </section>

      {/* ===== SEPARATOR ===== */}
      <hr className="help-divider" />

      {/* ===== WETLAND GUARDIAN VODIČ ===== */}
      <section className="help-section guide-title-section">
        <h2>Uputstvo</h2>
        <h2 className="guide-title">Wetland Guardian</h2>
        <p className="guide-subtitle">Vaš džepni vodič za građansku nauku</p>
      </section>

      {/* KORAK 1: PREPOZNAVANJE STANIŠTA */}
      <section className="help-section">
        <h2>Korak 1: Prepoznavanje staništa</h2>
        <p className="help-text">
          Uporedite ono što vidite sa fotografijama ispod.
        </p>

        <div className="guide-card-list">
          <div className="guide-card">
            <img src={pondImg} alt="Bara" className="zoomable" onClick={() => handleImageClick(pondImg, "Bara")} />
            <div className="guide-card-text">
              <strong>BARA</strong>
              <p>Mala, plitka stajaća voda. Često presuši tokom leta.</p>
            </div>
          </div>

          <div className="guide-card">
            <img src={swampImg} alt="Močvara" className="zoomable" onClick={() => handleImageClick(swampImg, "Močvara")} />
            <div className="guide-card-text">
              <strong>MOČVARA</strong>
              <p>Stalno vlažno područje obraslo gustom vegetacijom (trska/rogoz).</p>
            </div>
          </div>

          <div className="guide-card">
            <img src={lakeImg} alt="Jezero" className="zoomable" onClick={() => handleImageClick(lakeImg, "Jezero")} />
            <div className="guide-card-text">
              <strong>JEZERO</strong>
              <p>Velika i dublja vodena površina sa stabilnim nivoom vode.</p>
            </div>
          </div>

          <div className="guide-card">
            <img src={springImg} alt="Izvor" className="zoomable" onClick={() => handleImageClick(springImg, "Izvor")} />
            <div className="guide-card-text">
              <strong>IZVOR</strong>
              <p>Mesto gde hladna, bistra podzemna voda izbija (može biti betoniran).</p>
            </div>
          </div>

          <div className="guide-card">
            <img src={streamImg} alt="Potok" className="zoomable" onClick={() => handleImageClick(streamImg, "Potok")} />
            <div className="guide-card-text">
              <strong>POTOK</strong>
              <p>Mali vodotok sa brzom i bistrom tekućom vodom.</p>
            </div>
          </div>

          <div className="guide-card">
            <img src={riverImg} alt="Reka" className="zoomable" onClick={() => handleImageClick(riverImg, "Reka")} />
            <div className="guide-card-text">
              <strong>REKA</strong>
              <p>Veliki vodotok sa stalnim protokom.</p>
            </div>
          </div>

          <div className="guide-card">
            <img src={canalImg} alt="Kanal" className="zoomable" onClick={() => handleImageClick(canalImg, "Kanal")} />
            <div className="guide-card-text">
              <strong>KANAL</strong>
              <p>Veštački vodotok, ravan i prav.</p>
            </div>
          </div>

          <div className="guide-card">
            <img src={wetMeadowImg} alt="Vlažna livada" className="zoomable" onClick={() => handleImageClick(wetMeadowImg, "Vlažna livada")} />
            <div className="guide-card-text">
              <strong>VLAŽNA LIVADA</strong>
              <p>Travnata površina stalno vlažna ili poplavljena.</p>
            </div>
          </div>

          <div className="guide-card">
            <img src={peatBogImg} alt="Tresava" className="zoomable" onClick={() => handleImageClick(peatBogImg, "Tresava")} />
            <div className="guide-card-text">
              <strong>TRESAVA</strong>
              <p>Vlažno stanište sa puno mahovina (tresetnica), spužvasto.</p>
            </div>
          </div>
        </div>
      </section>

      {/* KORAK 2: STANJE VODE */}
      <section className="help-section">
        <h2>Korak 2: Stanje vode</h2>
        <p className="help-text">
          Pažljivo pogledajte površinu vode.
        </p>

        <h3>A. Bistrina</h3>
        <div className="guide-grid guide-grid-3">
          <div className="guide-grid-item">
            <img src={waterClearImg} alt="Bistra voda" className="zoomable" onClick={() => handleImageClick(waterClearImg, "Bistra voda")} />
            <strong>Bistra</strong>
            <p>Zdrav ekosistem.</p>
          </div>
          <div className="guide-grid-item">
            <img src={waterCloudyImg} alt="Blago mutna" className="zoomable" onClick={() => handleImageClick(waterCloudyImg, "Blago mutna")} />
            <strong>Blago mutna</strong>
            <p>Mlečna nijansa, prirodno posle kiše.</p>
          </div>
          <div className="guide-grid-item">
            <img src={waterMuddyImg} alt="Mutna" className="zoomable" onClick={() => handleImageClick(waterMuddyImg, "Mutna")} />
            <strong>Mutna</strong>
            <p>Upozorenje! Sediment ili zagađenje.</p>
          </div>
        </div>

        <h3>B. Boja</h3>
        <div className="guide-grid guide-grid-4">
          <div className="guide-grid-item">
            <img src={colorGreenImg} alt="Zelena" className="zoomable" onClick={() => handleImageClick(colorGreenImg, "Zelena")} />
            <strong>Zelena</strong>
            <p>Alge.</p>
          </div>
          <div className="guide-grid-item">
            <img src={colorBrownImg} alt="Braon" className="zoomable" onClick={() => handleImageClick(colorBrownImg, "Braon")} />
            <strong>Braon</strong>
            <p>Mulj/Erozija.</p>
          </div>
          <div className="guide-grid-item">
            <img src={colorGrayImg} alt="Siva" className="zoomable" onClick={() => handleImageClick(colorGrayImg, "Siva")} />
            <strong>Siva</strong>
            <p>Zagađenje.</p>
          </div>
          <div className="guide-grid-item">
            <img src={colorRedImg} alt="Crvenkasta" className="zoomable" onClick={() => handleImageClick(colorRedImg, "Crvenkasta")} />
            <strong>Crvenkasta</strong>
            <p>Minerali (Gvožđe).</p>
          </div>
        </div>

        <h3>C. Alge</h3>
        <p className="help-text">
          Ima li algi na površini?
        </p>
        <div className="guide-grid guide-grid-3">
          <div className="guide-grid-item">
            <img src={algaeNoneImg} alt="Nema algi" className="zoomable" onClick={() => handleImageClick(algaeNoneImg, "Nema algi")} />
            <strong>Nema</strong>
            <p>Čisto.</p>
          </div>
          <div className="guide-grid-item">
            <img src={algaeLittleImg} alt="Malo algi" className="zoomable" onClick={() => handleImageClick(algaeLittleImg, "Malo algi")} />
            <strong>Malo</strong>
            <p>Mrlje.</p>
          </div>
          <div className="guide-grid-item">
            <img src={algaeLotImg} alt="Mnogo algi" className="zoomable" onClick={() => handleImageClick(algaeLotImg, "Mnogo algi")} />
            <strong>Mnogo</strong>
            <p>Rizik od cvetanja.</p>
          </div>
        </div>
      </section>

      {/* KORAK 3: BIODIVERZITET */}
      <section className="help-section">
        <h2>Korak 3: Biodiverzitet</h2>
        <p className="help-text">
          Ko ovde živi?
        </p>

        <h3>Flora (Biljke)</h3>
        <div className="guide-grid guide-grid-3">
          <div className="guide-grid-item">
            <img src={floraWaterImg} alt="Biljke u vodi" className="zoomable" onClick={() => handleImageClick(floraWaterImg, "Biljke u vodi")} />
            <strong>U vodi</strong>
            <p>Lokvanji, trska.</p>
          </div>
          <div className="guide-grid-item">
            <img src={floraBankImg} alt="Biljke na obali" className="zoomable" onClick={() => handleImageClick(floraBankImg, "Biljke na obali")} />
            <strong>Na obali</strong>
            <p>Drveće, žbunje, trava.</p>
          </div>
          <div className="guide-grid-item">
            <img src={floraNoneImg} alt="Nema biljaka" className="zoomable" onClick={() => handleImageClick(floraNoneImg, "Nema biljaka")} />
            <strong>Nema biljaka</strong>
            <p>Nema biljaka.</p>
          </div>
        </div>

        <h3>Fauna (Životinje)</h3>
        <div className="guide-grid guide-grid-3">
          <div className="guide-grid-item">
            <img src={faunaFishImg} alt="Ribe" className="zoomable" onClick={() => handleImageClick(faunaFishImg, "Ribe")} />
            <strong>Ribe</strong>
            <p>Tražite mlađ ili mehuriće.</p>
          </div>
          <div className="guide-grid-item">
            <img src={faunaAmphibiansImg} alt="Vodozemci" className="zoomable" onClick={() => handleImageClick(faunaAmphibiansImg, "Vodozemci")} />
            <strong>Vodozemci</strong>
            <p>Žabe ukazuju na čistu vodu.</p>
          </div>
          <div className="guide-grid-item">
            <img src={faunaBirdsImg} alt="Ptice" className="zoomable" onClick={() => handleImageClick(faunaBirdsImg, "Ptice")} />
            <strong>Ptice</strong>
            <p>Vodene ptice ili grabljivice.</p>
          </div>
          <div className="guide-grid-item">
            <img src={faunaInsectsImg} alt="Insekti" className="zoomable" onClick={() => handleImageClick(faunaInsectsImg, "Insekti")} />
            <strong>Insekti</strong>
            <p>Vilini konjici = Zdravo.</p>
          </div>
          <div className="guide-grid-item">
            <img src={faunaReptilesImg} alt="Gmizavci" className="zoomable" onClick={() => handleImageClick(faunaReptilesImg, "Gmizavci")} />
            <strong>Gmizavci</strong>
            <p>Zmije ili kornjače.</p>
          </div>
          <div className="guide-grid-item">
            <img src={faunaOtherImg} alt="Drugo" className="zoomable" onClick={() => handleImageClick(faunaOtherImg, "Drugo")} />
            <strong>Drugo</strong>
            <p>Puževi, školjke.</p>
          </div>
        </div>
      </section>

      {/* KORAK 4: UPOZORENJE NA OPASNOST */}
      <section className="help-section">
        <h2>Korak 4: Upozorenje na opasnost</h2>
        <p className="help-text">
          Ako vidite ovo, prijavite odmah!
        </p>

        <h3>Zagađenje</h3>
        <div className="guide-grid guide-grid-3">
          <div className="guide-grid-item">
            <img src={threatChemicalImg} alt="Hemijsko zagađenje" className="zoomable" onClick={() => handleImageClick(threatChemicalImg, "Hemijsko zagađenje")} />
            <strong>Hemijsko</strong>
            <p>Masni sjaj, pena, miris.</p>
          </div>
          <div className="guide-grid-item">
            <img src={threatBiologicalImg} alt="Biološko zagađenje" className="zoomable" onClick={() => handleImageClick(threatBiologicalImg, "Biološko zagađenje")} />
            <strong>Biološko</strong>
            <p>Mrtve ribe, trulež.</p>
          </div>
          <div className="guide-grid-item">
            <img src={threatWasteImg} alt="Otpad" className="zoomable" onClick={() => handleImageClick(threatWasteImg, "Otpad")} />
            <strong>Otpad</strong>
            <p>Flaše, plastika.</p>
          </div>
        </div>

        <h3>Fizička oštećenja</h3>
        <div className="guide-grid guide-grid-3">
          <div className="guide-grid-item">
            <img src={threatErosionImg} alt="Erozija" className="zoomable" onClick={() => handleImageClick(threatErosionImg, "Erozija")} />
            <strong>Erozija</strong>
            <p>Urušene obale.</p>
          </div>
          <div className="guide-grid-item">
            <img src={threatDroughtImg} alt="Suša" className="zoomable" onClick={() => handleImageClick(threatDroughtImg, "Suša")} />
            <strong>Suša</strong>
            <p>Ispucala zemlja.</p>
          </div>
          <div className="guide-grid-item">
            <img src={threatBarrierImg} alt="Brana" className="zoomable" onClick={() => handleImageClick(threatBarrierImg, "Brana")} />
            <strong>Brana</strong>
            <p>Blokiran tok.</p>
          </div>
        </div>

        <h3>Ljudski faktor</h3>
        <div className="guide-grid guide-grid-3">
          <div className="guide-grid-item">
            <img src={threatOverfishingImg} alt="Krivolov" className="zoomable" onClick={() => handleImageClick(threatOverfishingImg, "Krivolov")} />
            <strong>Krivolov</strong>
            <p>Nelegalne mreže.</p>
          </div>
          <div className="guide-grid-item">
            <img src={threatLeadshotImg} alt="Sačma" className="zoomable" onClick={() => handleImageClick(threatLeadshotImg, "Sačma")} />
            <strong>Sačma</strong>
            <p>Toksične kuglice.</p>
          </div>
          <div className="guide-grid-item">
            <img src={threatRadioactiveImg} alt="Radioaktivno" className="zoomable" onClick={() => handleImageClick(threatRadioactiveImg, "Radioaktivno")} />
            <strong>Radioaktivno</strong>
            <p><strong>NE DIRATI!</strong></p>
          </div>
        </div>
      </section>

      {/* ZAVRŠNI KORAK */}
      <section className="help-section">
        <h2>Uslikaj i pošalji</h2>
        <p className="help-text">
          <strong>Vaša fotografija je dokaz.</strong> Pomaže stručnjacima da reaguju na zagađenje i prate klimatske promene.
        </p>
      </section>

      {zoomedImg && (
        <div className="help-lightbox" onClick={handleZoomClose}>
          <img src={zoomedImg.src} alt={zoomedImg.alt} />
        </div>
      )}
    </div>
  );
};

export default Help;
